import { keepImagesInMemory } from './imageCache';

export function preloadProjectImages(project) {
  const projectDir = `/assets/art-projects/${project.slug}`;
  const firstGalleryImage = project.images?.[0] ? `${projectDir}/${project.images[0]}` : null;

  keepImagesInMemory([project.leadImage, firstGalleryImage]);
}
